import { CardActionArea, cardContentClasses, cardHeaderClasses, Icon, SimpleWidgetCard, Stack, styled, Typography } from "@tm/components"
import { VoucherType } from "@tm/models"
import { forwardRef } from "react"
import { useWorkTask } from "@tm/context-distribution"
import { VoucherTypeSelector } from "../_shared/VoucherTypeSelector"

type Props = {
    title: string
    icon: string
    selectedVoucherType: VoucherType
    onChangeVoucherType(entry: VoucherType): void
}
const StyledSimpleWidgetCard = styled(SimpleWidgetCard)({
    [`&& .${cardHeaderClasses.root}`]: {
        padding: "0px",
        [`.${cardHeaderClasses.content}`]: {
            padding: "0px",
        },
    },
    [`&& .${cardContentClasses.root}`]: {
        padding: "0px",
    },
})

const StyledCardActionArea = styled(CardActionArea)({
    height: "100%",
    width: "100%",
})

const StyledStack = styled(Stack)(({ theme }) => ({
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
}))

export const WidgetSVariant = forwardRef(function WidgetSVariant(props: Props, ref) {
    const { title, icon, selectedVoucherType, onChangeVoucherType } = props

    const { workTask } = useWorkTask() ?? {}

    return (
        <StyledSimpleWidgetCard ref={ref} widgetVariant={workTask?.id ? "dashboard" : "startpage"}>
            <StyledCardActionArea disableRipple onClick={() => onChangeVoucherType(selectedVoucherType)}>
                <StyledStack>
                    <Stack gap="3px">
                        <Icon name={icon} size="large" />
                        <Typography variant="body2">{title}</Typography>
                    </Stack>
                    <VoucherTypeSelector
                        selectedVoucherType={selectedVoucherType}
                        onVoucherTypeChanged={onChangeVoucherType}
                        shouldTriggerOnSameSelected
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation()
                        }}
                    />
                </StyledStack>
            </StyledCardActionArea>
        </StyledSimpleWidgetCard>
    )
})
